import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { PerformedByType, } from '@debbie/common/dist/performed-by/index.js';
import THEME from '../../theme.js';
import ConnectPreview from './ConnectPreview.js';
import ImportPreview from './ImportPreview.js';
import IntegrationPreview from './IntegrationPreview.js';
import KeyPreview from './KeyPreview.js';
import UserPreview from './UserPreview.js';
import WorkflowPreview from './WorkflowPreview.js';
import Hovered from '../Hovered.js';
import TriggerPreview from './TriggerPreview.js';
import BulkActionPreview from './BulkActionPreview.js';
import UpdateTypePreview from './UpdateTypePreview.js';
const PerformedBy = (props) => {
    const lang = useSelector((s) => s.lang);
    const [active, setActive] = useState(false);
    const [hovered, setHovered] = useState(false);
    useEffect(() => {
        setActive(false);
    }, [props.performedBy]);
    const ref = useRef(null);
    if (props.performedBy == null) {
        return null;
    }
    const activate = () => {
        setActive(true);
    };
    const onMouseIn = () => {
        activate();
        setHovered(true);
    };
    const onMouseOut = () => {
        setHovered(false);
    };
    switch (props.performedBy.type) {
        case PerformedByType.Key: {
            return (React.createElement(Wrapper, { ref: ref, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
                React.createElement(Type, null, "API"),
                hovered ? (React.createElement(Popout, { parentRef: ref, header: `${lang.createdBy.createdBy} ${lang.createdByType[props.performedBy.type]}`, active: active },
                    React.createElement(KeyPreview, { id: props.performedBy.id }))) : null));
        }
        case PerformedByType.User: {
            return React.createElement(UserPreview, { id: props.performedBy.id });
        }
        case PerformedByType.Workflow: {
            return (React.createElement(Wrapper, { ref: ref, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
                React.createElement(Type, null, "wf"),
                hovered ? (React.createElement(Popout, { parentRef: ref, header: `${lang.createdBy.createdBy} ${lang.createdByType[props.performedBy.type]}`, active: active },
                    React.createElement(WorkflowPreview, { id: props.performedBy.id }))) : null));
        }
        case PerformedByType.Integration: {
            return (React.createElement(Wrapper, { ref: ref, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
                React.createElement(Type, null, "in"),
                hovered ? (React.createElement(Popout, { parentRef: ref, header: `${lang.createdBy.createdBy} ${lang.createdByType[props.performedBy.type]}`, active: active },
                    React.createElement(IntegrationPreview, { id: props.performedBy.id }))) : null));
        }
        case PerformedByType.Connect: {
            return (React.createElement(Wrapper, { ref: ref, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
                React.createElement(Type, null, "c"),
                hovered ? (React.createElement(Popout, { parentRef: ref, header: `${lang.createdBy.createdBy} ${lang.createdByType[props.performedBy.type]}`, active: active },
                    React.createElement(ConnectPreview, { id: props.performedBy.id }))) : null));
        }
        case PerformedByType.Import: {
            return (React.createElement(Wrapper, { ref: ref, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
                React.createElement(Type, null, "im"),
                hovered ? (React.createElement(Popout, { parentRef: ref, header: `${lang.createdBy.createdBy} ${lang.createdByType[props.performedBy.type]}`, active: active },
                    React.createElement(ImportPreview, { id: props.performedBy.id }))) : null));
        }
        case PerformedByType.Trigger: {
            return (React.createElement(Wrapper, { ref: ref, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
                React.createElement(Type, null, "tr"),
                hovered ? (React.createElement(Popout, { parentRef: ref, header: `${lang.createdBy.createdBy} ${lang.createdByType[props.performedBy.type]}`, active: active },
                    React.createElement(TriggerPreview, { id: props.performedBy.id, procedureId: props.performedBy.procedureId }))) : null));
        }
        case PerformedByType.VoucherApplication: {
            return (React.createElement(Wrapper, { ref: ref, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
                React.createElement(Type, null, "va"),
                hovered ? (React.createElement(Popout, { parentRef: ref, header: `${lang.createdBy.createdBy} ${lang.createdByType[props.performedBy.type]}`, active: active })) : null));
        }
        case PerformedByType.BulkAction: {
            return (React.createElement(Wrapper, { ref: ref, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
                React.createElement(Type, null, "ba"),
                hovered ? (React.createElement(Popout, { parentRef: ref, header: `${lang.createdBy.createdBy} ${lang.createdByType[props.performedBy.type]}`, active: active },
                    React.createElement(BulkActionPreview, { id: props.performedBy.id }))) : null));
        }
        case PerformedByType.UpdateTypeOnCaseEnd: {
            return (React.createElement(Wrapper, { ref: ref, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
                React.createElement(Type, null, "ut"),
                hovered ? (React.createElement(Popout, { parentRef: ref, header: `${lang.createdBy.createdBy} ${lang.createdByType[props.performedBy.type]}`, active: active },
                    React.createElement(UpdateTypePreview, { id: props.performedBy.id }))) : null));
        }
    }
};
const Wrapper = styled.div `
  transition: border-radius 0.1s ease-in-out;
  background: #bbb;
  padding: 0.2em 0.5em;
  border-radius: 5px;
  display: inline-block;
  cursor: default;
  color: white;
  position: relative;
`;
const Popout = (props) => {
    return (React.createElement(Hovered, { parentRef: props.parentRef },
        React.createElement(PopoutWrapper, { className: "popout" },
            React.createElement(PopoutHeader, null, props.header),
            props.active ? React.createElement(PopoutBody, null, props.children) : null)));
};
const PopoutHeader = styled.div `
  width: 100%;
  padding: 0.5rem;
  font-size: 1em;
  background: ${THEME.COLOR_ACCENT};
  color: ${THEME.COLOR_SECONDARY};
`;
const PopoutBody = styled.div `
  width: 100%;
  padding: 0.5rem;
`;
const PopoutWrapper = styled.div `
  transition: opacity 0.1s ease-in-out;
  overflow: hidden;

  background: white;
  color: ${THEME.COLOR_PRIMARY};
  border-radius: 5px;

  width: max-content;
  font-size: 0.8rem;
  font-weight: normal;

  box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.3);
`;
const Type = styled.span `
  font-size: 0.7rem;
  font-weight: normal;
  text-transform: uppercase;
`;
export default PerformedBy;
//# sourceMappingURL=PerformedBy.js.map